
import Constant from "@constant/index.js";
require("@util/myCarousel.js");

export default class RecommendView {
    constructor(model) {
        this._el = $("#_rcmd_good_ul");
        this._model = model;

        this._model._view = this;
    }

    getRedirectLink(url) {
        if (_terminal == Constant.TERMINAL.PC) {
            return url.pc;
        } else if (_terminal == Constant.TERMINAL.WAP) {
            return url.pc;
        } else {
            return url.pc;
        }
    }

    render() {
        if(this._model._data && this._model._data.length <= 0) {
            $('#cart_recommend_segment').hide();
            return;
        }
        try {
            let html = "";
            if (this._model._data && this._model._data instanceof Array && this._model._data.length > 0) {
                this._model._data.forEach(x => {
                    html += `<li class="_rcmd_good _dsp_off"  latag="latag_pc_cart_recommendItem_${x.position}_${x.strategy}_${x.goodsCode}"   >
                    <div class="_rcmd_good_tumb_c">
                        <a href="${this.getRedirectLink(x.url)}" target="_blank">
                            <img src="${x.thumbnail}" class="_rcmd_good_tumb"></a>
                    </div>
                    <span class="_rcmd_good_name">${x.name}</span>
                    <span class="_rcmd_good_price">￥${x.price.P_C.C_1.P_0.DV.V}</span>
                </li>`;
                })

                this._el.html($(html));

                $("#_rcmd_good_ul").carousel({
                    "_dsp_num": 4,                 // 自定义每次轮播切换的商品数量(最好是偶数)
                    "_dps_row": 1,                 // 自定义轮播商品展示行数
                    "_interval_time": 300000,              // 自动轮播间隔时间，单位ms
                    "_prev_btn": "#_rcmd_prev_btn", // 轮播上翻页按钮
                    "_next_btn": "#_rcmd_next_btn"  // 轮播下翻页按钮
                });
            } else {
                $("#_rcmd_good_ul").hide();
            }
        } catch (err) {
            console.log('pc端为你推荐-catch error', err);
            $('#cart_recommend_segment').hide();
        }
        setTimeout(() => {
            $('#_rcmd_prev_btn').trigger('click');
        },100);
    }
}